<template>
  <v-row class="d-flex align-center">
    <v-col cols="12" sm="8" md="9" :class="{ 'pb-2': $vuetify.display.xs }">
      <h4 class="text-h4">{{ heading }}</h4>
    </v-col>
    <v-col cols="12" sm="4" md="3" class="mt-0" :class="$vuetify.display.xs ? 'pb-5' : 'py-0'">
      <CurrencyDisplay
        v-model="amount"
        :max-length="6"
        @update:model-value="
          $emit('update:modelValue', $event);
          $emit('input', $event);
        "
        :label-id="'Monthly income needed'"
        :hide-details="true"
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import Slider from '@/components/Inputs/Slider/Slider.vue';
import CurrencyDisplay from './CurrencyDisplay.vue';

const componentOptions: ComponentOptions = {
  name: 'MonthlyIncome',
  components: {
    Slider,
    CurrencyDisplay,
  },
  data: () => ({
    amount: 0,
  }),
  props: {
    heading: {
      type: String,
      required: true,
      default: '',
    },
    modelValue: {
      type: [Number, String],
      required: true,
    },
    formInput: {
      type: Object,
      required: true,
    },
  },
  watch: {
    modelValue(value) {
      this.amount = value;
    },
  },
  mounted() {
    this.amount = this.modelValue;
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
:deep(.v-text-field input) {
  padding: 0px !important;
}
</style>
